<template>
  <div class="site">
    <div slot="container">
      <div class="base-search">
        <el-input placeholder="请输入内容" v-model="listQuery.ckeyword" class="input-with-select"
          @keyup.enter.native="search" clearable @clear="search" style="width: 240px">
          <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
        </el-input>
        <el-select v-model="listQuery.sourceType" placeholder="请选择来源类型" @change="search" style="width: 200px;">
          <el-option label="全部" :value="''" />
          <el-option label="科技创新券" :value="1" />
          <el-option label="大仪共享" :value="2" />
        </el-select>
        <el-select v-model="listQuery.palyType" placeholder="请选择支付方式" @change="search" style="width: 200px;margin-left:10px">
           <el-option label="全部" :value="''" />
          <el-option label="创新劵" :value="1" />
          <el-option label="人民币" :value="2" />
        </el-select>
        <!-- <el-button
          type="primary"
          class="exhibition.addBtn"
          @click="exportOut"
          :disabled="tableData.length == 0"
        >
          导出
        </el-button> -->
      </div>
      <div class="base-table">
        <el-table ref="multipleTable" :data="tableData" style="width: 100%"
          :header-cell-style="{ background: '#E5F3FE', color: '#623AA2' }" class="table">
          <el-table-column type="index" :index="index => {
            return index + (listQuery.page - 1) * listQuery.pageSize + 1;
          }
            " label="序号" align="center"></el-table-column>
          <el-table-column label="仪器/服务名称" align="center" prop="instrumentName"></el-table-column>
          <el-table-column label="机构名称" align="center" prop="serviceOrgName"></el-table-column>
          <el-table-column label="客户名称" align="center" prop="clientName"></el-table-column>
          <el-table-column label="联系方式" align="center" prop="contactInfo"></el-table-column>
          <el-table-column label="来源" align="center" prop="sourceName"></el-table-column>
          <el-table-column label="支付方式" align="center" prop="palyName"></el-table-column>
          <el-table-column label="备注" align="center" prop="customRemark"></el-table-column>
          <el-table-column label="预审核状态" align="center" prop="serviceOrgStatus">
            <template slot-scope="{ row }">
              <span>{{ row.serviceOrgStatus | orgStatusFilter }}</span>
            </template>
          </el-table-column>
          <el-table-column label="审核状态" align="center" prop="innovationOrgStatus">
            <template slot-scope="{ row }">
              <span>{{ row.innovationOrgStatus | orgStatusFilter }}</span>
            </template>
          </el-table-column>
          <el-table-column label="业务状态" align="center" prop="businessStatus">
            <template slot-scope="{ row }">
              <span>{{ row.businessStatus | statusFilter }}</span>
            </template>
          </el-table-column>
          <el-table-column label="服务状态" align="center" prop="serviceStatus">
            <template slot-scope="{ row }">
              <span>{{ row.serviceStatus | statusFilter }}</span>
              <span></span>
            </template>
          </el-table-column>
          <el-table-column width="240px" align="center" label="操作">
            <template slot-scope="scope">
              <el-button class="mini_btn" size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">
                编辑
              </el-button>
              <el-button class="mini_btn" size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination @current-change="handleCurrentChange" layout="total, prev, pager, next,jumper" :total="total"
        :current-page.sync="listQuery.page" style="text-align:left;margin:20px 0"
        :page-size="listQuery.pageSize"></el-pagination>
    </div>

    <el-dialog :visible.sync="dialogFormVisible" :title="Title" :close-on-click-modal="false" :append-to-body="true"
      @open="open">
      <el-form :model="ruleForm" ref="ruleForm" :rules="rules" label-width="120px">
        <div class="form-title">商品信息</div>
        <el-form-item label="仪器/服务名称" prop="instrumentName">
          <el-input v-model="ruleForm.instrumentName" placeholder="请输入仪器/服务名称" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="服务机构" prop="serviceOrgName">
          <el-input v-model="ruleForm.serviceOrgName" placeholder="请输入服务机构" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="使用费" prop="serviceFee1">
          <el-input v-model="ruleForm.serviceFee1" placeholder="请输入使用费" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="占用费" prop="serviceFee2">
          <el-input v-model="ruleForm.serviceFee2" placeholder="请输入占用费" :disabled="true"></el-input>
        </el-form-item>
        <div class="form-title">客户信息</div>
        <el-form-item label="客户名称" prop="clientName">
          <el-input v-model="ruleForm.clientName" placeholder="请输入客户名称" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="联系方式" prop="contactInfo">
          <el-input v-model="ruleForm.contactInfo" placeholder="请输入联系方式" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="customRemark">
          <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入备注"
            v-model="ruleForm.customRemark" :disabled="isDetail"></el-input>
        </el-form-item>

        <div class="form-title">审核信息</div>
        <el-form-item label="审批状态" prop="serviceOrgStatus" style="text-align:left">
          <el-select v-model="ruleForm.serviceOrgStatus" placeholder="请选择审核状态" style="display: block;"
            :disabled="isDetail">
            <el-option label="待审核" :value="1"></el-option>
            <el-option label="不通过" :value="2"></el-option>
            <el-option label="退回" :value="3"></el-option>
            <el-option label="通过" :value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="审核意见" prop="auditOpinion">
          <el-input v-model="ruleForm.auditOpinion" placeholder="请填写审核意见" :disabled="isDetail"></el-input>
        </el-form-item>
        <el-form-item label="附件上传" prop="file">
          <el-upload class="upload-demo" :action="this.uploadURL" style="text-align: left;" :disabled="isDetail"
            :before-upload="beforeFileUploadLimit"
            :on-remove="(file, fileList) => handleFileRemove(file, fileList, 'file')" :file-list="file" :on-success="(response, file, fileList) => handleFileSuccess(response, file, fileList, 'file')
              ">
            <el-button size="small" type="primary" :disabled="isDetail">
              上传附件材料
            </el-button>
          </el-upload>
        </el-form-item>
        <!--<el-form-item label="业务状态" prop="businessStatus">
          <el-radio v-model="ruleForm.businessStatus" :label="0">未完成</el-radio>
          <el-radio v-model="ruleForm.businessStatus" :label="1">已完成</el-radio>
        </el-form-item>-->
        <el-form-item label="评分">
          <el-rate style="line-height: 2.5;" v-model="ruleForm.record.rating" disabled></el-rate>
        </el-form-item>
        <el-form-item label="评价">
          <el-input v-model="ruleForm.record.content" placeholder="" disabled></el-input>
        </el-form-item>
        <el-form-item label="服务状态" prop="serviceStatus">
          <el-radio v-model="ruleForm.serviceStatus" :label="0">未完成</el-radio>
          <el-radio v-model="ruleForm.serviceStatus" :label="1">已完成</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="createSite">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>
<script>
const orgStatus = {
  1: '待审核',
  2: '不通过',
  3: '退回',
  4: '通过'
};
const status = {
  0: '未完成',
  1: '已完成'
};
export default {
  components: {},
  filters: {
    orgStatusFilter(state) {
      return orgStatus[state];
    },
    statusFilter(state) {
      return status[state];
    }
  },
  data() {
    return {
      Title: '',
      // 1待审核, 2不通过, 3退回, 4通过
      approvalStatus: '',
      formApprovalStatus: '',
      listQuery: {
        keyword: '',
        is_page: 0,
        page: 1,
        pageSize: 10,
        sourceType: '',
        palyType: ''
      },
      serviceTypeList: [
        {
          label: '检测检验',
          id: 1
        },
        {
          label: '委托开发',
          id: 2
        },
        {
          label: '专利申请代理',
          id: 3
        },
        {
          label: '技术转移',
          id: 4
        }
      ],
      dialogVisible: false,
      dialogFormVisible: false,
      dialogType: '',
      dialogImageUrl: '',
      file: [],

      is_edit: false,
      headerStyle: {
        color: '#623AA2',
        background: '#E5F3FE'
      },
      orgTypeList: [],
      investmentList: [],
      number: 0,
      operationType: 'add',
      per_page: 10,
      total: 20,
      dialogFormVisible: false,
      ruleForm: {
        instrumentId: null, // 仪器服务id
        instrumentName: null, // 仪器服务名称
        serviceOrgId: null, // 服务机构id
        serviceOrgName: null, // 服务机构名称
        serviceFee1: null, // 服务费用-使用费
        serviceFee2: null, // 服务费用-占用费
        clientName: null, // 客户名称
        contactInfo: null, // 联系方式
        customRemark: null, // 备注
        auditOpinion: null, // 审核意见
        serviceOrgStatus: null, // 服务机构审核状态:1待审核, 2不通过 3退回, 4通过
        serviceOrgStatusName: null, // 服务机构审核状态:1待审核, 2不通过 3退回, 4通过
        innovationOrgStatus: null, // 创新券机构审核状态:1待审核, 2不通过 3退回, 4通过
        innovationOrgStatusName: null, // 创新券机构审核状态:1待审核, 2不通过 3退回, 4通过
        businessStatus: null, // 业务状态: 0未完成, 1已完成
        businessStatusName: null, // 业务状态: 0未完成, 1已完成
        record: {},
        serviceStatus: null, // 服务状态: 0未完成, 1已完成
        serviceStatusName: null // 服务状态: 0未完成, 1已完成
      },
      rules: {
        // orgName: [{ required: true, message: '请输入机构名称', trigger: 'blur' }],
      },
      tableData: [],
      limit: 1,
      showUpload1: false,
      showUpload2: false
    };
  },
  computed: {
    isDetail() {
      return this.dialogType === 'detail' && this.formApprovalStatus === 4;
    }
  },
  created() {
    this.getData();
    // this.getGroup();
  },
  methods: {
    //导出
    exportOut() {
      let url = this.urlConfig.url + 'export_Active_List';
      var a = document.createElement('a');
      a.href = url;
      a.download = '';
      a.click();
    },
    beforeFileUploadLimit(file) {
      if (this.file.length === 1) {
        return this.$message.warning('您已经上传了一份附件，请删除后重新上传');
      }
      const isLt2M = file.size / 1024 / 1024 < 100;
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 100MB!');
      }
      return isLt2M;
    },
    handleFileRemove(file, fileList, type) {
      this.file = fileList;
      this.fileListChange(type);
    },
    handleFileSuccess(response, file, fileList, type) {
      if (response.code == 0) {
        this.file = fileList;
        this.fileListChange(type);
      }
    },
    //搜索
    search() {
      this.listQuery.page = 1;
      this.getData();
    },
    async open() {
      if (this.dialogType === 'add') {
        this.resetData();
      } else if (this.dialogType === 'edit' || this.dialogType === 'detail') {
        this.getDetail();
      }
    },
    async getDetail() {
      try {
        const res = await this.http.get(
          `${this.urlConfig.devUrl}apij2/admin-api/innovation/instrument-apply/get?id=${this.queryId}`
        );
        console.log(res, 'res');
        if (res.code === 0) {
          this.ruleForm = Object.assign(this.ruleForm, res.data);
          if (this.ruleForm.record) {
            this.file = res.data.record.file ? JSON.parse(res.data.record.file) : [];
            this.ruleForm.auditOpinion = res.data.record.auditOpinion || '';
            this.$set(this.ruleForm, 'auditOpinion', res.data.record.auditOpinion || '');
          } else {
            this.ruleForm.record = {
              rating: 0,
              content: ''
            };
            this.ruleForm.auditOpinion = '';
            this.file = [];
          }
        } else {
          this.resetData();
        }
      } catch (e) {
        console.log(e);
      }
    },
    getData() {
      this.http
        .post(
          this.urlConfig.devUrl + 'apij2/admin-api/innovation/instrument-apply/pageAdmin',
          this.listQuery
        )
        .then(res => {
          if (res.code == 0) {
            this.tableData = res.data.data;
            this.total = res.data.total;
          }
        });
    },
    //选择页码
    handleCurrentChange(e) {
      this.listQuery.page = e;
      this.getData();
    },
    // 获取数据字典
    getGroup(row) {
      let obj = {
        dictTypes: ['financial_institution_category', 'financial_investment_stage']
      };
      this.http.post(`${urlConfig.devUrl}apij2/admin-api/system/dict-data/getGroup`, obj).then(
        response => {
          if (response.code == 0) {
            console.log('response', response);
            this.orgTypeList = response.data.financial_institution_category;
            this.investmentList = response.data.financial_investment_stage;
            // this.ruleForm = response.data
          } else {
            this.$message.error(response.status);
          }
        },
        error => { }
      );
    },
    checkLimit(filelist, index) {
      const limit = this.limit;
      console.log(this.$refs['upload' + index]);
      const uploadDom = this.$refs['upload' + index];
      if (filelist.length === limit) {
        uploadDom.$children[1].$el.style.display = 'none';
        this['showUpload' + (index + 1)] = true;
      } else {
        uploadDom.$children[1].$el.style.display = '';
        this['showUpload' + (index + 1)] = false;
      }
    },
    selectChange(e, list, props) {
      if (e) {
        this.ruleForm[props] = list.find(item => item.id === e).label;
      } else {
        this.ruleForm[props] = '';
      }
      console.log('this.ruleForm[props]', this.ruleForm[props]);
    },
    // 修改按钮操作
    editOperate() {
      this.$refs['ruleForm'].validate(valid => {
        if (valid) {
          this.http
            .post(`${urlConfig.devUrl}apij2/admin-api/innovation/instrument-apply/update`, {
              ...this.ruleForm
            })
            .then(res => {
              if (res.code == 0) {
                this.$message.success('编辑成功');
                this.dialogFormVisible = false;

                this.resetData();
                this.getData();
              } else {
                this.$message.error(res.status);
              }
            })
            .catch(err => {
              this.dialogFormVisible = false;
            });
        } else {
          this.is_edit = true;

          console.log('error submit!!');
          return false;
        }
      });
    },
    resetData() {
      this.ruleForm = {
        instrumentId: null, // 仪器服务id
        instrumentName: null, // 仪器服务名称
        serviceOrgId: null, // 服务机构id
        serviceOrgName: null, // 服务机构名称
        serviceFee1: null, // 服务费用-使用费
        serviceFee2: null, // 服务费用-占用费
        clientName: null, // 客户名称
        contactInfo: null, // 联系方式
        customRemark: null, // 备注
        serviceOrgStatus: null, // 服务机构审核状态:1待审核, 2不通过 3退回, 4通过
        serviceOrgStatusName: null, // 服务机构审核状态:1待审核, 2不通过 3退回, 4通过
        innovationOrgStatus: null, // 创新券机构审核状态:1待审核, 2不通过 3退回, 4通过
        innovationOrgStatusName: null, // 创新券机构审核状态:1待审核, 2不通过 3退回, 4通过
        businessStatus: null, // 业务状态: 0未完成, 1已完成
        record: {},
        businessStatusName: null, // 业务状态: 0未完成, 1已完成
        serviceStatus: null, // 服务状态: 0未完成, 1已完成
        serviceStatusName: null // 服务状态: 0未完成, 1已完成
      };
    },

    //城市选择
    citySelected(e) {
      if (e.province.value) {
        this.ruleForm.orgProvince = e.province.value;
      }
      if (e.city.value) {
        this.ruleForm.orgCity = e.city.value;
      }
      if (e.area.value) {
        this.ruleForm.orgDistrict = e.area.value;
      }
    },
    deleteImg(type) {
      this.$confirm('确定删除图片吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
        .then(() => {
          this.fileListChange(type, []);
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //编辑
    handleEdit(index, row) {
      this.dialogFormVisible = true;
      this.Title = '编辑';
      this.dialogType = 'edit';
      this.queryId = row.id;
      this.formApprovalStatus = row.approvalStatus;
    },
    handleDetail(index, row) {
      this.dialogFormVisible = true;
      this.Title = '详情';
      this.dialogType = 'detail';
      this.queryId = row.id;
      this.formApprovalStatus = row.approvalStatus;
    },
    handleDelete(index, row) {
      this.$confirm('确定删除该条记录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
        .then(() => {
          const obj = {
            ids: [row.id]
          };
          this.http
            .delete(`${urlConfig.devUrl}apij2/admin-api/innovation/instrument-apply/delete`, obj)
            .then(res => {
              if (res.code == 0) {
                this.listQuery.page = 1;
                this.getData();
                this.$message({
                  type: 'success',
                  message: '删除成功'
                });
              } else {
                this.$message({
                  message: '失败！',
                  type: 'error'
                });
              }
            });
        })
        .catch(() => { });
    },
    addDataNew() {
      this.dialogFormVisible = true;
      this.Title = '新增';
      this.dialogType = 'add';
      this.file = [];
    },
    // 确认添加机构
    createSite() {
      this.$refs['ruleForm'].validate(valid => {
        if (valid) {
          this.http
            .post(`${urlConfig.devUrl}apij2/admin-api/innovation/instrument-apply/update`, {
              ...this.ruleForm
            })
            .then(res => {
              if (res.code == 0) {
                this.$message.success('编辑成功');
                this.dialogFormVisible = false;
                this.resetData();
                this.getData();
              } else {
                this.$message.error(res.status);
              }
            })
            .catch(err => {
              this.dialogFormVisible = false;
            });
        } else {
          this.is_edit = true;

          console.log('error submit!!');
          return false;
        }
      });
    },
    handleRemove(file, type) {
      this.$confirm('确定删除图片吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
        .then(() => {
          for (var i = 0; i < this[type].length; i++) {
            if (file.uid == this[type][i].uid) {
              this[type].splice(i, 1);
            }
          }
          console.log(this[type]);
          this.fileListChange(type);

          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    handleAvatarSuccess(response, file, fileList, type) {
      if (response.code == 0) {
        this[type] = fileList;
        this.fileListChange(type);
      }
    },
    fileListChange(type) {
      let arr = [];
      if (this[type].length > 0) {
        this[type].map(item => {
          arr.push({
            url: item.size ? this.imgUrl + item.response.data.store_result : item.url,
            name: item.name
          });
        });
        this.ruleForm[type] = JSON.stringify(arr);
      } else {
        this.ruleForm[type] = '';
        this[type] = [];
      }
    },
    beforeAvatarUpload(file) {
      let type = false;
      if (
        file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'image/jpg' ||
        file.type === 'image/gif' ||
        file.type === 'image/bmp'
      ) {
        type = true;
      }

      var img = new Image();
      img.src = this.image;
      img.onload = function () { };

      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!type) {
        this.$message.error('上传图片只能是 JPEG/jpg/png/gif/bmp 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 10MB!');
      }
      return type && isLt2M;
    }
  }
};
</script>
<style lang="scss">
@include component(site) {
  width: 100%;
  height: 100%;

  @include part(header) {
    display: flex;
    justify-content: flex-start;

    @include component(el-input) {
      width: 300px;
    }
  }

  .base-search {
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    /deep/.el-input--suffix {
      width: 100%;
      margin: 0 15px;
    }

    .el-input {
      // width: 400px;
      margin: 0 15px;
    }

    .date-picker {
      margin: 0 15px;

      .el-range-separator {
        width: auto;
      }
    }
  }

  .base-table {
    width: 100%;
    margin-top: 20px;
    border: 1px solid #eef1f6;
  }

  .el-select {
    width: 100%;
    margin: 0;
  }

  @include part(form) {
    margin: 30px auto;
    width: 50%;
  }

  @include component(rowItem) {
    width: 50%;
  }

  .el-form-item__content {
    text-align: left;
  }

  /deep/.upload-demo {
    border: none;
  }
}

.form-title {
  width: 100%;
  text-align: left;
  color: #623aa2;
  border-left: 5px solid #623aa2;
  border-bottom: 1px solid #623aa2;
  padding-left: 10px;
  font-size: 20px;
  margin-bottom: 20px;
  font-weight: 700;
}
</style>
